export default "__VITE_ASSET__a2c3ea3f__"